<template>
  <!-- 活动详情--报名/签到 -->
  <div class="eventDetails_box">
    <van-nav-bar :title="'活动详情'"
                 left-text
                 left-arrow
                 @click-left="onClickLeft"
                 :fixed="true" />
    <div class="content">
      <div class="top"
           :class="(type == 'signIn' || !can_enroll) ? 'no_Footer_top' : ''">
        <div class="event_box"
             v-for="(item,idx) in baseinfo"
             :key="idx">
          <van-collapse v-model="activeInfoNames"
                        class="infoData_coll">
            <van-collapse-item name="1">
              <template #title>
                <div style="display: flex; font-weight: bold">
                  <img style="width: 24px; height: 24px; margin-right: 10px"
                       src="@/assets/img/shishikecheng.png"
                       alt />
                  活动信息
                </div>
              </template>
              <div class="event_top">
                <div class="event_title">
                  <div class="title">{{item.at_subject}}</div>
                </div>
                <div class="event_body">
                  <div class="cell">{{item.at_bd_ed}}</div>
                  <div class="cell">{{item.at_address_location}}</div>
                  <div class="cell">{{item.enroll_bd_ed}}</div>
                  <div class="cell">{{item.at_charge_name_phone}}</div>
                  <div class="cell"
                       v-html="item.at_details_info?item.at_details_info.replace(/\n/g, '<br>'):''"></div>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
        <!-- 附件信息 -->
        <div class="event_box">
          <van-collapse v-model="activeFuJianNames"
                        class="infoData_coll">
            <van-collapse-item name="1">
              <template #title>
                <div style="display: flex; font-weight: bold">
                  <img style="width: 24px; height: 24px; margin-right: 10px"
                       src="@/assets/img/shishikecheng.png"
                       alt />
                  附件信息
                </div>
              </template>
              <div class="fuJian_content"
                   v-if="filelist.length>0">
                <div class="file_box">
                  <div class="file_item"
                       v-for="(pdf,fidx) in filelist"
                       :key="'pdf'+fidx">
                    <img @click="visitFile(pdf)"
                         class="iconImg"
                         src="@/assets/img/xmind.png"
                         alt="">
                    <div class="fileName">{{pdf.sfilename}}</div>
                  </div>
                </div>
              </div>
              <div v-else
                   style="margin-top: 30px; font-size: 17px; text-align: center;">{{$t('module.NoData')}}</div>
            </van-collapse-item>
          </van-collapse>
        </div>
        <!-- 拉拉队提示 -->
        <div class="event_box"
             v-if="type == 'signIn'">
          <van-collapse v-model="activeLaLaDuiNames"
                        class="infoData_coll">
            <van-collapse-item name="1">
              <template #title>
                <div style="display: flex; font-weight: bold">
                  <img style="width: 24px; height: 24px; margin-right: 10px"
                       src="@/assets/img/shishikecheng.png"
                       alt />
                  拉拉队提示
                </div>
              </template>
              <div class="fuJian_content"
                   v-if="baseinfo[0].cheering_remark">
                <div class="cheering_remark_box">
                  {{baseinfo[0].cheering_remark}}
                </div>
              </div>
              <div v-else
                   style="margin-top: 30px; font-size: 17px; text-align: center;">{{$t('module.NoData')}}</div>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div class="event_box">
          <!-- 比赛项目 -->
          <van-collapse v-model="activeProjectNames"
                        class="infoData_coll">
            <van-collapse-item name="1">
              <template #title>
                <div style="display: flex; font-weight: bold">
                  <img style="width: 24px; height: 24px; margin-right: 10px"
                       src="@/assets/img/shishikecheng.png"
                       alt />
                  {{type == 'signUp'?'参赛项目报名':'比赛项目'}}
                </div>
              </template>
              <div v-if="projectData.length>0">
                <div class="event_top"
                     v-for="(item,pidx) in projectData"
                     :key="'pro'+pidx">
                  <div class="pro_title">
                    <div class="title">{{item.prjname}}</div>
                    <div v-if="type == 'signUp'"
                         class="enroll_txt">{{item.enroll_count}}/{{item.plan_enroll_count}}</div>
                  </div>
                  <div class="pro_body">
                    <div class="cell">{{item.yymmdd}}</div>
                    <div class="cell">{{item.bt_et}}</div>
                  </div>
                  <div class="btn"
                       v-if="can_enroll">
                    <!-- 取消报名 -->
                    <div class="btn_box"
                         v-if="type == 'signUp' && item.show_cancel_btn">
                      <van-button type="danger"
                                  size="small"
                                  class="btn1"
                                  @click="cancelRegistration(item)">{{ '取消报名' }}</van-button>
                    </div>
                    <div class="btn_box">
                      <img v-if="type == 'signUp' && item.is_enroll_competitor"
                           style="width: 75px"
                           src="@assets/img/yibaoming.png"
                           class="img1" />
                      <img v-if="type == 'signIn' && item.is_cheering_signin"
                           style="width: 75px"
                           src="@assets/img/yiqiandao.png"
                           class="img2" />
                      <van-button type="primary"
                                  size="small"
                                  class="btn1"
                                  :disabled="(type == 'signUp' && item.is_enroll_competitor) || (type == 'signIn' && item.is_cheering_signin)"
                                  @click="goToRegister(item,type == 'signUp' ? 0 : 2,'a',0)">{{type == 'signUp' ? '参赛报名' :'拉拉队签到'}}</van-button>
                    </div>
                    <!-- 签退 -->
                    <div class="btn_box"
                         v-if="type == 'signIn'">
                      <img v-if=" type == 'signIn' && item.is_cheering_signout"
                           style="width: 75px"
                           src="@assets/img/yiqiantui.png"
                           class="img2" />
                      <van-button type="primary"
                                  size="small"
                                  class="btn1"
                                  :disabled="type == 'signIn' && item.is_cheering_signout"
                                  @click="goToRegister(item, 2,'c',1)">{{ '拉拉队签退' }}</van-button>
                    </div>
                    <!-- 签到名单 -->
                    <div class="btn_box"
                         v-if="type == 'signIn'">
                      <van-button type="info"
                                  size="small"
                                  class="btn1"
                                  @click="viewRegistration(item,'signIn')">{{ '签到名单' }}</van-button>
                    </div>
                    <div v-if="type == 'signUp'"
                         class="btn_box">
                      <van-button type="info"
                                  size="small"
                                  @click="viewRegistration(item,'signUp')"> {{ '查看报名'}}</van-button>
                    </div>
                  </div>
                  <van-divider v-if="pidx <= projectData.length-2" />
                </div>
                <!-- 只有报名才显示 -->
                <van-divider class="footer_divider" />
                <div class="footer"
                     v-if="type == 'signUp' && can_enroll">
                  <div class="button"
                       :class="can_click?'noclickFooter':''"
                       @click="goToRegister({autoid:0},1,'b')">{{ '工作人员报名' }}</div>
                  <img v-if="baseinfo[0] ? baseinfo[0].is_enroll_worker : false"
                       style="width: 75px"
                       src="@assets/img/yibaoming.png"
                       class="top_img" />
                </div>
              </div>
              <div v-else
                   style="margin-top: 30px; font-size: 17px; text-align: center;">{{$t('module.NoData')}}</div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>

    </div>
    <!-- 拍照上传弹窗 -->
    <PhotoUpload ref="refPhotoUpload"
                 @returnToAttachment="returnToAttachment"></PhotoUpload>
    <!-- pdf内置播放器 -->
    <PdfView :pdf="pdfUrl"></PdfView>

    <!-- 已经报名的人员名单 -->
    <van-popup v-model="showPrjEmp"
               class="IA_PrjEmp_pop"
               position="right"
               :style="{ width: '100%', height: '100%' }">
      <van-nav-bar :title="empListTile"
                   left-arrow
                   @click-left="showPrjEmp = false"
                   :fixed="true">
      </van-nav-bar>
      <div class="emp_content"
           v-if="prjEmpList.length>0">
        <div class="emp_box"
             v-for="(emp,eidx) in prjEmpList"
             :key="'emp'+eidx">
          <div class="title">
            <div class="empname">{{emp.empname}}</div>
            <div class="empcode">{{emp.empcode}}</div>
          </div>
          <div class="dept">
            <div>{{emp.deptname}}</div>
            <div v-if="empListType == 'signIn'">
              <span>签到：</span>
              <span>{{emp.signin_time}}</span>
            </div>
          </div>
          <div class="station">
            <div>{{emp.staname}}</div>
            <div v-if="empListType == 'signIn'">
              <span>签退：</span>
              <span>{{emp.signout_time}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="nodata"
           v-else>{{$t('module.NoData')}}</div>
    </van-popup>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import { getActivityDetailsInfo, activityEnroll, activitySignIn, getActivityPrjEmpList, getActivityPrjEmpSignList, activityCancelEnroll } from '@api/integral.js'
import PhotoUpload from "../components/photoUpload.vue";
import PdfView from "@components/pdfView/index.vue";
export default {
  components: {
    PhotoUpload,
    PdfView
  },
  data () {
    let type = this.$route.query.from
    let autoid = this.$route.query.autoid
    const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
    return {
      userInfo,
      type,
      autoid,
      baseinfo: [],
      projectData: [],
      event: {},
      activeInfoNames: ['1'],
      activeFuJianNames: ['1'],
      activeLaLaDuiNames: ['1'],
      activeProjectNames: ['1'],
      filelist: [],
      pdfUrl: '',
      showPrjEmp: false,
      prjEmpList: [],
      empListTile: '',
      empListType: ''
    }
  },
  computed: {
    // 是否显示报名/签到按钮
    can_enroll () {
      return this.baseinfo[0] ? this.baseinfo[0].can_enroll : false
    },
    // 报名/签到按钮是否能点击
    can_click () {
      return this.baseinfo[0] ? this.baseinfo[0].is_enroll_worker : false
    }
  },
  created () {
    this.type = this.$route.query.from
    this.autoid = this.$route.query.autoid
    this.getActivityDetailsInfoData()
  },
  methods: {
    // 取消报名
    cancelRegistration (item) {
      Dialog.confirm({
        title: this.$t('module.systemhint'),
        message: '您确定要取消该比赛项目的报名吗？',
      }).then(() => {
        activityCancelEnroll({
          autoid: this.autoid,
          at_plan_id: item.autoid,
          username: this.userInfo.username
        }).then(res => {
          if (res.data[0].info)
          {
            Toast.fail(res.data[0].info);
          } else
          {
            Toast.success(this.$t('module.submitScu'));
            this.getActivityDetailsInfoData()
          }
        })
      }).catch(() => {
        // on cancel
      });
    },
    // 查看附件
    visitFile (pdf) {
      this.pdfUrl = pdf.fileurl + "?time=" + new Date().getTime();
    },
    // 查看报名
    viewRegistration (item, type) {
      this.empListType = type
      if (type == 'signIn')
      {
        // 签到名单
        this.empListTile = '已签到人员'
        getActivityPrjEmpSignList({
          mautoid: this.autoid,
          prjid: item.autoid,
          username: this.userInfo.username
        }).then(res => {
          this.prjEmpList = res.data
          this.showPrjEmp = true
        })
      } else
      {
        this.empListTile = '已报名人员'
        // 报名名单
        getActivityPrjEmpList({
          mautoid: this.autoid,
          prjid: item.autoid,
          username: this.userInfo.username
        }).then(res => {
          this.prjEmpList = res.data
          this.showPrjEmp = true
        })
      }
    },
    // 签到回调-拍照 base64
    returnToAttachment (files) {
      // console.log(files, 'filesfilesfilesfilesfiles');
      let params = {
        autoid: this.autoid,
        username: this.userInfo.username,
        enroll_typeid: this.event.enroll_typeid,
        at_plan_id: this.event.at_plan_id,
        filebase64str_pic1: files[0] ? files[0] : '',
        filebase64str_pic2: files[1] ? files[1] : '',
        filebase64str_pic3: files[2] ? files[2] : '',
        signflag: this.event.signflag
      }
      console.log(params, 'params2223333');
      Dialog.confirm({
        title: this.$t('module.systemhint'),
        message: this.$t('module.areUsureUwantTosubmit'),
      }).then(() => {
        activitySignIn(params).then(res => {
          if (res.data[0].info)
          {
            Toast.fail(res.data[0].info);
          } else
          {
            Toast.success(this.$t('module.submitScu'));
            this.getActivityDetailsInfoData()
          }
        })
      }).catch(() => {
        // on cancel
      });
    },
    // 报名/签到
    goToRegister (item, typeid, position, signflag) {
      console.log(item, 'goToRegister', typeid, position, signflag);
      if (this.can_click && typeid == 1)
      {
        return
      }
      let params = {
        autoid: this.autoid,
        enroll_typeid: typeid,
        at_plan_id: item.autoid,
        username: this.userInfo.username
      }
      if (this.type == 'signUp')
      {
        // 报名
        Dialog.confirm({
          title: this.$t('module.systemhint'),
          message: typeid == 1 ? '您确定报名工作人员吗？' : '您确定要报名参赛吗？',
        }).then(() => {
          activityEnroll(params).then(res => {
            if (res.data[0].info)
            {
              Toast.fail(res.data[0].info);
            } else
            {
              Toast.success(this.$t('module.submitScu'));
              this.getActivityDetailsInfoData()
            }
          })
        }).catch(() => {
          // on cancel
        });
      } else
      {
        // 签到
        this.event = {
          enroll_typeid: typeid,
          at_plan_id: item.autoid,
          signflag: signflag
        }
        this.$refs.refPhotoUpload.showUploadDia = true
      }
    },
    // 获取活动详情
    getActivityDetailsInfoData () {
      getActivityDetailsInfo({
        autoid: this.autoid,
        username: this.userInfo.username
      }).then(res => {
        this.baseinfo = res.baseinfo
        this.projectData = res.data
        this.filelist = res.filelist
      })
    },
    // 返回
    onClickLeft () {
      if (this.$route.query.from == 'signUp')
      {
        this.$router.push({ path: '/eventRegistration', query: { from: this.$route.query.parents } })
      } else
      {
        this.$router.push({ path: '/eventSignIn', query: { from: this.$route.query.parents } })
      }
    },
  }

}
</script>

<style lang="less" scoped >
.eventDetails_box {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
  }
  .content {
    // overflow: auto;
    position: relative;
    margin-top: 1.22667rem;
    height: calc(100% - 92px);
    .top {
      height: 100%;
      overflow-y: auto;
      padding: 20px;
      .event_box {
        margin-bottom: 40px;
        .van-collapse {
          /deep/.van-collapse-item {
            .van-cell__title {
              font-size: 36px;
              color: #7232dd;
            }
            .van-collapse-item__wrapper {
              border-radius: 0 0 40px 40px;
            }
          }
        }
        /deep/.event_top {
          position: relative;
          background: #ffffff;
          padding: 0 20px;
          border-radius: 40px;
          .top_img {
            position: absolute;
            bottom: 0;
            right: 0;
          }
          .event_title {
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .title {
              font-size: 40px;
              font-weight: bold;
              // color: #6ecaf2;
              color: #42baed;
            }
          }
          .pro_title {
            display: flex;
            justify-content: space-between;
            background-image: linear-gradient(to right, #a7c6ff, #ffffff);
            padding: 10px 20px;
            .title {
              font-size: 32px;
              font-weight: bold;
              color: #333333;
            }
            .enroll_txt {
              font-size: 32px;
              color: #ee0a24;
            }
          }
          .event_body {
            font-size: 30px;
            color: #333333;
            .cell {
              margin: 20px 10px;
            }
          }
          .pro_body {
            font-size: 28px;
            .cell {
              margin: 20px 10px;
              color: #333333;
            }
          }
          .btn {
            display: flex;
            justify-content: flex-end;
            .btn_box {
              position: relative;
              display: flex;
              .btn1 {
                margin-right: 20px;
              }
              .img1 {
                position: absolute;
                top: -40px;
                left: -8px;
              }
              .img2 {
                position: absolute;
                top: -30px;
                left: 6px;
              }
            }
          }
          .van-divider::before {
            border-color: #f6f6f6;
            border-width: 20px;
          }
        }
        .footer_divider {
          padding: 0 20px;
        }
        .footer_divider::before {
          border-color: #f6f6f6;
          border-width: 20px;
        }
        .footer {
          width: 100%;
          height: 100px;
          font-size: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          // margin-top: 40px;
          .button {
            height: 80px;
            line-height: 80px;
            width: 80%;
            text-align: center;
            background: #2b8df0;
            color: #fff;
            font-size: 36px;
            border-radius: 12px;
          }
          .noclickFooter {
            opacity: 0.5;
          }
          .top_img {
            position: absolute;
            top: -25%;
            left: 40%;
          }
        }
        .fuJian_content {
          .file_box {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            .file_item {
              width: 33.3%;
              text-align: center;
              margin-bottom: 20px;
              .fileName {
                font-size: 28px;
                color: #333333;
              }
            }
          }
          .cheering_remark_box {
            font-size: 30px;
            color: #333333;
          }
        }
      }
    }
    .no_Footer_top {
      height: 100%;
    }
  }
  // 拍照弹窗
  .IA_PrjEmp_pop {
    height: 100vh;
    width: 100%;
    .van-nav-bar {
      background: #2b8df0;
      /deep/ .van-nav-bar__left {
        .van-icon {
          color: #fff;
        }
      }
      /deep/.van-nav-bar__title {
        color: #fff;
        font-size: 36px;
        font-family: Source Han Sans CN;
      }
    }
    .nodata {
      margin-top: 1.22667rem;
      height: calc(100% - 92px);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 36px;
      font-weight: bold;
      color: #333333;
    }
    .emp_content {
      overflow-y: auto;
      position: relative;
      margin-top: 1.22667rem;
      height: calc(100% - 92px);
      padding: 20px;
      background-color: #f6f6f6;
      .emp_box {
        background: #ffffff;
        border-radius: 30px;
        padding: 20px;
        margin-bottom: 30px;
        .title {
          display: flex;
          font-size: 36px;
          justify-content: space-between;
          .empname {
            font-size: 36px;
            color: #000000;
          }
          .empcode {
            font-size: 36px;
            color: #07c160;
          }
        }
        .dept,
        .station {
          font-size: 28px;
          color: #8e8e8e;
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>